import React, { Component } from 'react';
// import cx from 'classnames';
import styles from './_mobilePurchasePlans.module.scss';

export default class MobilePurchasePlans extends Component {
  render() {
    const { planData } = this.props;
    return (
      <div className={styles['mobile-purchase-plans']}>
        <div className={styles['title']}>{planData?.title}</div>
        <div className={styles['bank-images']}>
          <img src="/images/hdfc2.svg" alt="hdfc" className={styles['hdfc-img']} />
          <img src="/images/sbi2.svg" alt="sbi" />
          <img src="/images/icici2.svg" alt="icici" className={styles['icici-img']} />
        </div>
        <div className={styles['desc']}>{planData?.footerText}</div>
      </div>
    );
  }
}
